

const CUTOFF_LANG = ['ZH_CN', 'JA_JP', 'KO_KR']

export default CUTOFF_LANG